import templateUrl from './datepicker.html'

export const datepickerComponent = {
	bindings: {
		details: '<',
		onChange: '&'
	},
	templateUrl,
	controller: class DatepickerComponent {
		constructor(defaultErrorMessageResolver) {
			'ngInject';

			defaultErrorMessageResolver.getErrorMessages().then((errorMessages) => {
				errorMessages['dateRequired'] = 'Please select date';
			});
		}

		$onInit() {
			this.datepickerOptions = {};
			this.startDatepickerOptions = {};
			this.endDatepickerOptions = {};
			//this.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
			//this.format = this.formats[1];
			if (!this.details) {
				this.details = {};
			}
			if (!this.details.hasOwnProperty('isRequired')) {
				this.details.isRequired = true;
			}
			// if(this.details.selectedDate) {
			// 	this.details.selectedDate = this.details.selectedDate.toString();
			// }
			if (this.details.range) {
				this.startDatePopupOpened = false;
				this.endDatePopupOpened = false;
				if (this.details.range.startDate.disablePreviousDates) {
					this.startDatepickerOptions.minDate = new Date();
				}
				if (this.details.range.endDate.disablePreviousDates) {
					this.endDatepickerOptions.minDate = new Date();
				}
				if(!this.details.range.startDate.hasOwnProperty('isRequired')){
					this.details.range.startDate.isRequired = true;
				}
				if(!this.details.range.endDate.hasOwnProperty('isRequired')){
					this.details.range.endDate.isRequired = true;
				}
				//disabled future dates
				if (this.details.range.startDate.disableFutureDates) {
					this.startDatepickerOptions.maxDate = new Date();
					this.startDatepickerOptions.maxDate.setDate(this.startDatepickerOptions.maxDate.getDate() - 1);
				}
				if (this.details.range.endDate.disableFutureDates) {
					this.endDatepickerOptions.maxDate = new Date();
					this.endDatepickerOptions.maxDate.setDate(this.endDatepickerOptions.maxDate.getDate() - 1);
				}
			} else {
				if (this.details.disablePreviousDates) {
					if(this.details.minDate) {
						this.datepickerOptions.minDate = new Date(this.details.minDate);
						this.datepickerOptions.minDate.setDate(this.datepickerOptions.minDate.getDate() + 1);
					} else {
						this.datepickerOptions.minDate = new Date();
					}
				}

				//disabled future dates
				if (this.details.disableFutureDates) {
					this.datepickerOptions.maxDate = new Date();
					this.datepickerOptions.maxDate.setDate(this.datepickerOptions.maxDate.getDate() - 1);
				}
			}
		}
		open() {
			if (!this.details.disableDate)
				this.opened = true;
		}
		openStartDatePopup() {
			this.startDatePopupOpened = true;
		}
		openEndDatePopup() {
			this.endDatePopupOpened = true;
		}
		$onChanges(changes) {
			if(changes.details && changes.details.currentValue) {
				this.$onInit();
			}
		}

		_onChange(details) {
			if (this.details.range.endDate.endDateGreaterThanStartDate) {
				this.endDatepickerOptions.minDate = new Date(this.details.range.startDate.selectedDate);
				this.endDatepickerOptions.minDate.setDate(this.endDatepickerOptions.minDate.getDate() + 1);
			}
			this.onChange({
				details
			});
		}
	}

};



// WEBPACK FOOTER //
// ./src/app/common/components/datepicker/datepicker.component.js